import { Typography, withStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import formStyles from '../../../../../collums-constants/styles/stylesheets/formStyles';
import PropTypes from 'prop-types';
import { useForms } from '../../../../hooks/forms';

const ParagraphWidget = ({ classes, widgetProps, nextFieldRequired, nextFieldHasError }) => {
    const { isReadOnly, isJourney } = useForms();
    const showRequiredError = isJourney && !isReadOnly && nextFieldRequired && nextFieldHasError;
    const content = useMemo(() => {
        if (!widgetProps.content) {
            return <></>;
        }
        const splittedContent = widgetProps.content.split('\n');
        if (splittedContent.length === 1) {
            return (
                <Typography
                    className={`${classes.paragraphContent} ${isReadOnly ? classes.textDisabled : ''}`}
                    style={showRequiredError ? { color: '#f44336' } : undefined}
                >
                    {widgetProps.content}
                    {nextFieldRequired ? ' *' : ''}
                </Typography>
            );
        }
        return splittedContent.map((content, index) => {
            return (
                <>
                    <Typography
                        className={`${classes.paragraphContent} ${isReadOnly ? classes.textDisabled : ''} ${
                            index !== splittedContent.length ? classes.breakParagraph : ''
                        }`}
                        style={showRequiredError ? { color: '#f44336' } : undefined}
                    >
                        {content}
                        {index === splittedContent.length - 1 && nextFieldRequired ? ' *' : ''}
                    </Typography>
                </>
            );
        });
    }, [
        widgetProps,
        classes.paragraphContent,
        classes.breakParagraph,
        isReadOnly,
        classes.textDisabled,
        nextFieldRequired,
        showRequiredError
    ]);

    return (
        <div id={widgetProps.id}>
            {widgetProps.title && (
                <Typography
                    component="h2"
                    variant="h2"
                    className={`${classes.paragraphTitle} ${isReadOnly ? classes.textDisabled : ''}`}
                >
                    {widgetProps.title}
                </Typography>
            )}
            {content}
        </div>
    );
};

ParagraphWidget.propTypes = {
    classes: PropTypes.object.isRequired,
    widgetProps: PropTypes.object.isRequired,
    nextFieldRequired: PropTypes.bool,
    nextFieldHasError: PropTypes.bool
};

export default withStyles(formStyles)(ParagraphWidget);
